import React from "react";
import MuiButton from "@mui/material/Button";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { styled } from '@mui/material/styles';
import pxToRem from "libs/pxToRem";
import environment from "environment";

const VerOperacionEuro: React.FC<{ operacionId: number }> = ({
  operacionId,
}) => {
  const handleClick = () => {
    const url = `${environment.euroWebUrl}/webpages/gcvistacreditoconsumo.aspx?id=${operacionId}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Button onClick={handleClick} endIcon={<OpenInNewIcon />}>
      Ver en Euro
    </Button>
  );
};

export default VerOperacionEuro;

const Button = styled(MuiButton)({
  height: pxToRem(28),
  marginLeft: pxToRem(8),
  whiteSpace: "nowrap",
});
Button.defaultProps = {
  variant: "contained",
  color: "secondary",
  size: "small",
};
